import React from 'react';
import Carosel from '../Carosel/Carosel';
import Product from '../Product/Product';


const Home = () => {    
    return (
        <div>                          
            <Carosel></Carosel>
            <Product></Product>                
        </div>
    );
};

export default Home;